import { useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import { Spin } from "antd";

import Styles from "./styles/appDetails.module.scss";

const AppDetails = () => {
  const { id } = useParams(); // Embedded app ID
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);

  // Parse optional query parameter 'app_path' for the embedded app route
  const searchParams = new URLSearchParams(location.search);
  const appPath = searchParams.get("app_path") || "";

  // Determine the base URL for the embedded app (local vs dev server)
  const isLocalApp = process.env.REACT_APP_IS_LOCAL === "true";
  const localAppUrl = process.env.REACT_APP_APP_URL;
  const devServerUrl = process.env.REACT_APP_BACKEND_API_HOST;
  const iframeBaseUrl = isLocalApp ? localAppUrl : devServerUrl;

  // Construct iframe URL:
  //   - /app/<id> points to the embedded app
  //   - #/<route> is handled by the embedded app's internal router
  const iframeSrc = `${iframeBaseUrl}/app/${id}/#${appPath ? (appPath.startsWith("/") ? appPath : `/${appPath}`) : ""}`;

  return (
    <div className={Styles["app-details-wrapper"]}>
      {isLoading && <Spin />}
      <iframe
        src={iframeSrc}
        title={`Embedded app ${id}`}
        id="app"
        style={{ width: "100%", height: "100%", border: "none" }}
        onLoad={() => setIsLoading(false)}
      />
    </div>
  );
};

export default AppDetails;
